import { helpers, required, requiredIf } from "@vuelidate/validators";
import validationJson from "~/static/locale/it/validation.json";
import Validator from "~/utils/validator";

// get generic validation locale merged with theme defined validation locale
const { locale } = await useLocale("validation", null, true);

export default {
  employerName: {
    required: helpers.withMessage(
      () => locale?.value?.required ?? validationJson.required,
      required,
    ),
  },
  employeeLoan: {
    required: helpers.withMessage(
      () => locale?.value?.required ?? validationJson.required,
      //@ts-ignore
      requiredIf(function (value: string, { showEmployeeLoan }: any) {
        return !!(showEmployeeLoan ?? false);
      }),
    ),
  },
  familyMemberCount: {
    required: helpers.withMessage(
      () => locale?.value?.required ?? validationJson.required,
      //@ts-ignore
      requiredIf(function (value: number, { showFamilyMemberCount }: any) {
        return showFamilyMemberCount;
      }),
    ),
    nonZero: Validator.nonZeroIf("showFamilyMemberCount"),
  },
  employedFamilyMemberCount: {
    required: helpers.withMessage(
      () => locale?.value?.required ?? validationJson.required,
      //@ts-ignore
      requiredIf(function (value: number, { familyMemberCount }: any) {
        return familyMemberCount.value > 1;
      }),
    ),
    nonZero: Validator.nonZeroIf("showFamilyMemberCount"),
  },
};
